module.exports = __webpack_public_path__ + "media/images/lb/599-d2dd39b020fdb3ccf6c9506d6ea70315.svg";